import React, { useMemo } from 'react';

import CloseIcon from '../../assets/images/common/close.svg';

import { Prefecture, City, MasterPrefectureApiResponse } from '../../types/api/MasterPrefectureApiType';
import { ChangeFieldItemInput, DeviceInfoInputRow } from '../../types/common/EstimateInquiryType';
import { MODEL_COUNT } from '../../types/common/EstimationType';

import { FieldItemInput } from './FieldItemInput';

type EditDeviceListEditRowProps = {
    inputRow: DeviceInfoInputRow; // 行情報
    index: number; // 行index番号
    inputListLength: number;
    setStateRowValue: (changeRowValue: DeviceInfoInputRow) => void; // 行setState
    deleteEditRow: (changeRowNum: number) => void; // 行削除
    masterPrefecture: MasterPrefectureApiResponse;
};

export const EditDeviceListEditRow: React.FC<EditDeviceListEditRowProps> = ({
    inputRow,
    index,
    inputListLength,
    setStateRowValue,
    deleteEditRow,
    masterPrefecture,
}) => {
    // select 都道府県
    const prefectureList = useMemo<Array<Prefecture>>(() => masterPrefecture.prefecture, []);
    // select 市
    const cityList = useMemo<Array<City>>(() => masterPrefecture.city, []);

    const setFieldItemInput = (changeRowValue: ChangeFieldItemInput) => {
        void setStateRowValue({ ...inputRow, ...changeRowValue });
    };

    return (
        <div className='edit-device-list-edit-row'>
            <h3>設置場所</h3>
            <FieldItemInput
                inputData={inputRow}
                setInputData={setFieldItemInput}
                prefectureList={prefectureList}
                cityList={cityList}
            />
            <div className='select vol'>
                <select
                    onChange={(e) =>
                        setStateRowValue({ ...inputRow, unitCount: e.target.value })
                    }
                    value={inputRow.unitCount}
                >
                    {MODEL_COUNT.map((num) => (
                        <option
                            key={`edit-row-${index}-${inputRow.inputRowNumber}-unitCount-${num.value}`}
                            value={num.value}
                        >
                            {num.caption}
                        </option>
                    ))}
                </select>
            </div>
            <input
                type='text'
                onChange={(e) =>
                    setStateRowValue({ ...inputRow, freeText: e.target.value })
                }
                value={inputRow.freeText}
                className='edit-row-freeword'
                placeholder='機器に関する備考を入力してください。　例：検証環境用'
            />
            <div className='edit-row-icon'>
                {inputListLength > 1 ? (
                    <span className='icon is-small'>
                        <img src={CloseIcon} alt='' onClick={() => {
                            if (inputRow.inputRowNumber !== undefined) {
                                deleteEditRow(inputRow.inputRowNumber)
                            }
                        }} />
                    </span>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
